import React, { useState} from "react";

import './CreateChild3.scss';

import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import {createChild, reinstateChild} from "root/DataFunctions/ChildDataFns";
import useModalReinstateChild from "root/Modals/ModalReinstateChild/useModalReinstateChild";
import {ModalReinstateModes} from "root/Modals/ModalReinstateChild/ModalReinstateChild";
import {useNavigate} from "react-router-dom";

export const newChildModes = {
    RETURNING: 'returning',
    NEW: 'new'
}
const CreateChild3 = () =>
{
    const navigate = useNavigate();

    const [stage, setStage] = useState( { thisStage: 1, initialChild: undefined });

    const [data, setData] = useState ({} );

    const [ renderModal, showReinstateModal ] = useModalReinstateChild( ( result, child_id ) =>
    {
        navigate( '/vschool') ;
    });

    const notify = ( { stage, fragment, initialChild, action } ) =>
    {
        if ( action === 'submit' )
        {
            if ( data.form.mode === newChildModes.RETURNING )
            {
                reinstateChild( data.form.child_id, data, (response) =>
                {
                    showReinstateModal({ mode: ModalReinstateModes.COMPLETE, child_id: null })
                })
            }
            else if ( data.form.mode === newChildModes.NEW )
            {
                // If this is the final page creating a child, the fragment parameters
                // will contain the las page of the form. so we need to merge it with the
                // previously saved data before submitting

                const finalData = { ...data, ...fragment } ;

                createChild( finalData, (response) =>
                {
                    showReinstateModal({ mode: ModalReinstateModes.COMPLETE, child_id: null })
                })
            }
        }
        else
        {
            if ( fragment !== undefined )
            {
                setData ( { ...data, ...fragment } ) ;
            }

            setStage ( { thisStage: stage, initialChild: initialChild } ) ;
        }
    }

    const renderPage = () =>
    {
        switch (stage.thisStage)
        {
            case 1:
                return <Page1 notify={notify}/>
            case 2:
                return <Page2 mode={data.form?.mode} notify={notify} initialChild={stage.initialChild}/>
            case 3:
                return <Page3 mode={data.form?.mode} notify={notify} />
            case 4:
                return <Page4 notify={notify} formData={data} />
        }
    }

    return (
        <div className='create-child-page'>
            {renderPage()}
            {renderModal()}
        </div>
    )
}

export default CreateChild3;